import { Component, Input, OnChanges, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { Currency } from 'projects/common/model/landingModel';
import { OfferCardData, OfferCardDataPrice, OfferCardType } from "../offer-card-data.model";
import { LoyaltyMode } from '@shopping-angular-components/loyalty'
import { MediaPictureService } from "../../../services/media-picture.service";
import { LandingModelService } from 'projects/common/services/landingModel.service';

@Component({
  selector: 'offer-card-pricebox',
  template: `
    <div *ngIf="price" class="offer-card-pricebox {{offerCardType}}" [ngClass]="{'with-reference-date': data.reference_date}">
        <span class="discount-top-label -benefits eva-3-driver"
              *ngIf="price.promo?.discount_top_label">
          <span class="driver-text">
            <span class="-eva-3-tc-gray-0">{{price.promo.discount_top_label?.label}} </span>
            {{price.promo.discount_top_label?.discount_text}}
          </span>
        </span>
        <div class="offer-card-pricebox-description">{{price.message}}</div>
        <div class="offer-card-pricebox-price">
          <div class="offer-card-pricebox-price-current">
            <div *ngIf="data.two_pax_promo" class="price-2x -eva-3-mr-xsm">2x</div>
            <span class="offer-card-pricebox-price-currency -eva-3-mr-xsm">{{currency.symbol}}</span>
            <span class="offer-card-pricebox-price-amount">{{price.total_amount}}</span>
          </div>
          <span class="offer-card-pricebox-price-old" *ngIf="price.promo?.real_price">
            {{currency.symbol}} {{price.promo.real_price}}
          </span>
          <span *ngIf="price.points"
                class="offer-card-pricebox-price-points eva-3-caption -eva-3-bold -eva-3-mb-xsm">
            {{(loyaltyPointsName ? 'offers.points.label' : 'offers.points.labelDefault') | translate: {points: price.points.toLocaleString(locale.replace('_', '-')), pointsName: loyaltyPointsName} }}
          </span>
        </div>
        <div class="offer-card-pricebox-label eva-3-label {{labelSizeClassName}} {{positionLabelClassName}}"
            *ngIf="((price.promo?.ribbon && !price.promotions_list) || price.promo?.discount) && !data.shopping_cart_link?.url"
            [ngClass]="price.promo.promo_type === 'CROSS_SELLING' ? '-purple' :
            price.promo.promo_type === 'HOTSALE' ? '-hotsale' :
            price.promo.promo_type === 'LOGGED_IN' ? '-secret-deals' :
            price.promo.promo_type === 'IFOOD' ? '-ifood' : '-green'">
          <span class="label-container">
            <i *ngIf="price.promo.promo_type === 'CROSS_SELLING'"
                class="label-icon eva-3-icon-pig-offer-filled -eva-3-mr-xsm"></i>
            <i *ngIf="price.promo.promo_type === 'COUPON'"
                class="label-icon eva-3-icon-{{isStressContent ? 'pm-pad' : 'ticket'}} -eva-3-mr-xsm"></i>
            <i *ngIf="price.promo.promo_type === 'HOTSALE'"
                class="label-icon eva-3-icon-promotion -eva-3-mr-xsm"></i>
            <i *ngIf="price.promo.promo_type === 'LOGGED_IN'"
                class="eva-3-icon-gift  label-icon -eva-3-tc-red-3"></i>
            
            <span class="-eva-3-bold label-text">{{getRibbon()}}</span>
          </span>
        </div>

        <dual-promo *ngIf="price.promotions_list && !data.shopping_cart_link?.url"
                    [promotionsList]="price.promotions_list | reverseArray"
                    [position]="positionLabelClassName"
                    [ngClass]="positionLabelClassName"></dual-promo>

        
        <div *ngIf="data.shopping_cart_link?.url" class="shopping-cart" [ngClass]="{'-aligned': data.reference_date && !price.promo?.real_price}">
          <button class="eva-3-btn-ghost -md -circle" [title]="'offers.buttons.addToCart' | translate" (click)="handleShoppingCartClick($event, data.shopping_cart_link?.url)" >
            <i class="eva-3-icon-trolley btn-icon -eva-3-icon-sm"></i>
          </button>
        </div>

        <div *ngIf="price.tax_message" class="offer-card-pricebox-description 
              {{price.disclaimer ? 'tax-message-with-disclaimer' : 'tax-message'}}">{{price.tax_message}}</div>

        <div *ngIf="price.disclaimer"
              class="offer-card-pricebox-description disclaimer-message">{{price.disclaimer}}</div>

        <div *ngIf="data.see_more_offers_link?.title && data.see_more_offers_link?.url" class="-eva-3-mt-md -eva-3-mb-sm">
          <button class="eva-3-btn -md -primary" name="">
            <em class="btn-text">{{data.see_more_offers_link.title}}</em>
          </button>
        </div>
        
  </div>

    <span *ngIf="data.reference_date" class="offer-card-reference-date">
        <div>{{'offers.smallText.date' | translate}}</div>
        <div class="offer-card-small-text">{{data.reference_date}}</div>
    </span>

    <loyalty-offer-info *ngIf="offerCardType !== OfferCardType.REDUCED && offerCardType !== OfferCardType.BASIC" [loyaltyInfo]="data.loyalty_info" [loyaltyMode]="loyaltyMode"
                        [locale]="locale" [flow]="flow"></loyalty-offer-info>

    <div class="offer-card-payment" *ngIf="offerCardType !== OfferCardType.REDUCED && (data.payments || paymentsMediaKey)">
      <img *ngIf="paymentsMediaKey" class="offer-card-payment-image" src="{{paymentsMediaKey}}" loading="lazy" alt="cards icon">
      <p class="offer-card-payment-text" *ngIf="data.payments" [innerHTML]="data.payments"></p>
    </div>
  `,
  styleUrls: ['./offer-card-pricebox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferCardPriceboxComponent implements OnInit, OnChanges {
  readonly OfferCardType = OfferCardType;

  @Input() data: OfferCardData;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() loyaltyMode: LoyaltyMode | null;
  @Input() flow;
  @Input() offerCardType: OfferCardType;

  @Output() shoppingCartClicked = new EventEmitter<string>();

  price: OfferCardDataPrice;
  paymentsMediaKey?: string;
  isMobile: boolean;
  positionLabelClassName: '-top-left' | '-top-right' | '-bottom-left' | '-bottom-right';
  labelSizeClassName: string = '-sm';
  loyaltyPointsName: string;
  isStressContent: boolean;

  constructor(public mediaPictureService: MediaPictureService, private landingModelService: LandingModelService) {
    this.isStressContent = landingModelService.getLandingModel().abTests?.ab.includes("S-PIG-RETURNERS|branch_test");
  }

  ngOnInit(): void {
    this.initPrice();
    this.paymentsMediaKey = this.mediaPictureService.getMediaUrl(this.data.payments_media_key);
    this.positionLabelClassName = this.offerCardType === OfferCardType.REDUCED ? '-top-left' : '-top-right';
    this.loyaltyPointsName = this.landingModelService.getLandingModel().keywordsMap['HOME_WL_POINTS_NAME']?.toLocaleLowerCase();
  }

  ngOnChanges(): void {
    this.initPrice();
  }

  private initPrice(): void {
    if (this.data.offer_alternatives) {
      this.price = this.data.offer_alternatives[0].price[this.currency.code];
    } else if (this.data.price) {
      this.price = this.data.price[this.currency.code];
    }
  }

  getRibbon(): string {
    return this.price.promo.ribbon || `- ${this.price.promo.discount}%`;
  }

  handleShoppingCartClick(event: MouseEvent, url: string | undefined): void {
    if (url) {
      event.stopPropagation();
      event.preventDefault();
      this.shoppingCartClicked.emit(url);
    }
  }

}
